import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlloyButton } from 'cat-ecommerce-alloy';
import ExceptionFeedbackBySelector from '@app/components/common/Exception/ExceptionFeedbackBySelector';

const ExceptionFeedbackModal = ({
  errorSelector,
  tryAgainButtonProps = {},
  onCancelImportButton = () => {},
  cancelImportButtonClassName = ''
}) => {
  const [t] = useTranslation();

  const { buttonType, size, className } = tryAgainButtonProps;

  return (
    <ExceptionFeedbackBySelector className="mb-3" selector={errorSelector}>
      <div className="text-start my-1 d-flex flex-column flex-md-row">
        <AlloyButton
          buttonType={buttonType || 'secondary'}
          className={`me-lg-4 mb-2 mb-lg-0 ${className}`}
          size={size || 'dynamic'}
          {...tryAgainButtonProps}
        >
          {t('TRY_AGAIN')}
        </AlloyButton>
        <AlloyButton
          buttonType="ghost"
          className={cancelImportButtonClassName}
          onClick={onCancelImportButton}
          size="dynamic"
        >
          {t('CANCEL_IMPORT')}
        </AlloyButton>
      </div>
    </ExceptionFeedbackBySelector>
  );
};

ExceptionFeedbackModal.propTypes = {
  errorSelector: PropTypes.func.isRequired,
  tryAgainButtonProps: PropTypes.shape({
    onClick: PropTypes.func,
    type: PropTypes.string
  }),
  onCancelImportButton: PropTypes.func,
  cancelImportButtonClassName: PropTypes.string
};

export default ExceptionFeedbackModal;
